module.exports = "/logo-white-ba3f6c36813d60203127165081ca8c20.svg";